import {createRouter, createWebHistory} from "vue-router";

import { isAuthenticated } from '@/utils/auth';

import store from '@/store';

import LogIn from "@/components/LogIn.vue";
import SceneUsr from "@/components/SceneUsr.vue";
import RegUsr from "@/components/hr/RegUser.vue";
import RegPwd from "@/components/RegPwd.vue";
import ManageDepartments from "@/components/hr/ManageDepartments.vue";
import ManageJobTitles from "@/components/hr/ManageJobTitles.vue";
import ManageUsers from "@/components/hr/ManageUsers.vue";
import HomePage from "@/components/general-comp/HomePage.vue";
import EditUser from "@/components/hr/EditUser.vue";
import CurrentInventory from "@/components/inv/CurrentInventory.vue";
import ExpenseObject from "@/components/inv/ManageExpenseObject.vue";
import Providers from "@/components/inv/ManageProviders.vue";
import ViewUser from "@/components/hr/ViewUser.vue";
import ManageProducts from "@/components/inv/ManageProducts.vue";
import ManageProductInvoice from "@/components/inv/ManageProductInvoice.vue";
import regProductInvoice from "@/components/inv/RegInvoice.vue";
import manageRequisitions from "@/components/inv/ManageRequisitions.vue";
import regRequisitions from "@/components/inv/RegRequisitions.vue";
import manageTransfers from "@/components/inv/ManageTransfers.vue";
import regTransfer from "@/components/inv/RegTransfer.vue";
import showInvoice from "@/components/inv/ShowInvoice.vue";
import ShowRequisition from "@/components/inv/ShowRequisition.vue";
import NotificationsViewer from "@/components/general-comp/NotificationsViewer.vue";
import ShowTransfer from "@/components/inv/ShowTransfer.vue";
import ReportsViewer from "@/components/inv/ReportsViewer.vue";
import TicketCreate from "@/components/TicketCrear.vue";
import LeavePermit from "@/components/hr/LeavePermit.vue";
import VacationsList from "@/components/hr/Vacations.vue";
import LicencesList from "@/components/hr/Licences.vue";


const routes = [
    {
        name: "logInPage",
        component: LogIn,
        path: "/"
    },
    {
        name: "regPassword",
        component: RegPwd,
        path: "/regPwd"
    },
    {
      name: "createTicket",
      component: TicketCreate,
      path: "/ticket/create"
    },
    {
        name: "scene",
        component: SceneUsr,
        path: "/scene",
        redirect: "/scene/home",
        beforeEnter: async (to, from, next) => {
            if(await isAuthenticated()) {
                next();
            } else {
                next({ name: 'logInPage'});
            }
        },
        children: [
            {
                path: 'regusr',
                component: RegUsr,
                name: 'RegUsr',
                meta: { requiresClearance: 'hr-usr-reg' }
            },
            {
                path: 'edit_usr/:id',
                component: EditUser,
                name: 'EditUsr',
                meta: { requiresClearance: 'hr-usr-edit' }
            },
            {
                path: 'manage_departments',
                component: ManageDepartments,
                name: 'ManageDepartments',
                meta: { requiresClearance: 'hr-dep-search' }
            },
            {
                path: 'manage_job_titles',
                component: ManageJobTitles,
                name: 'ManageJobTitles',
                meta: { requiresClearance: 'hr-jot-search' }
            },
            {
                path: 'manage_users',
                component: ManageUsers,
                name: 'ManageUsers',
                meta: { requiresClearance: 'hr-usr-search' }
            },
            {
                path: 'home',
                component: HomePage,
                name: 'HomePage'
            },
            {
                path: 'current_inventory',
                component: CurrentInventory,
                name: 'CurrentInventory',
                meta: { requiresClearance: 'ad-prov-inventory-search' }
            },
            {
                path: 'expense_objects',
                component: ExpenseObject,
                name: 'ExpenseObject',
                meta: { requiresClearance: 'ad-prov-expense-obj-search' }
            },
            {
                path: 'manage_product_invoice',
                component: ManageProductInvoice,
                name: 'ManageProductInvoice',
                meta: { requiresClearance: 'ad-prov-invoice-search' }
            },
            {
                path: 'providers',
                component: Providers,
                name: 'Providers',
                meta: { requiresClearance: 'ad-prov-providers-search' }
            },
            {
                path: 'view_user/:id',
                component: ViewUser,
                name: 'ViewUsers',
                meta: { requiresClearance: 'hr-usr-search' }
            },
            {
                path: 'manage_products',
                component: ManageProducts,
                name: 'ManageProduct',
                meta: { requiresClearance: 'ad-prov-prod-search' }
            },
            {
                path: 'register_invoice',
                component: regProductInvoice,
                name: 'RegisterInvoice',
                meta: { requiresClearance: 'ad-prov-invoice-reg' }
            },
            {
                path: 'manage_requisitions',
                component: manageRequisitions,
                name: 'ManageRequisitions',
                meta: { requiresClearance: 'ad-prov-requisition-search' }
            },
            {
                path: 'register_requisitions',
                component: regRequisitions,
                name: 'RegisterRequisitions',
                meta: { requiresClearance: 'ad-prov-requisitions-reg' }
            },
            {
                path: 'manage_transfers',
                component: manageTransfers,
                name: 'ManageTransfers',
                meta: { requiresClearance: '' }
            },
            {
                path: 'register_transfer',
                component: regTransfer,
                name: 'RegisterTransfer',
                meta: { requiresClearance: 'ad-prov-transfer-dispatch' }
            },
            {
                path: 'show_invoice/:id',
                component: showInvoice,
                name: 'ShowInvoice',
                meta: { requiresClearance: 'ad-prov-invoice-search' }
            },
            {
                path: 'show_requisition/:id',
                component: ShowRequisition,
                name: 'ShowRequisition',
                meta: { requiresClearance: 'ad-prov-requisition-search' }
            },
            {
                path: 'notification_viewer',
                component: NotificationsViewer,
                name: 'NotificationsViewer',
            },
            {
                path: 'show_transfer/:id',
                component: ShowTransfer,
                name: 'ShowTransfer',
                meta: { requiresClearance: 'ad-prov-transfer-search' }
            },
            {
                path: 'reports_viewer',
                component: ReportsViewer,
                name: 'ReportsViewer',
                meta: { requiresClearance: 'ad-prov-reports' }
            },
            {
                path: 'leave_permit',
                component: LeavePermit,
                name: 'LeavePermit',
            },
            {
                path: 'vacations',
                component: VacationsList,
                name: 'VacationsList',
            },
            {
                path: 'licences',
                component: LicencesList,
                name: 'LicencesList',
            },
            {
                path: '',
            }

        ]
    },

    {
        path: '/:pathMatch(.*)*',
        redirect: '/scene/home'
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresClearance)) {
        const requiredClearance = to.meta.requiresClearance;
        if (store.getters.userData && store.getters.hasClearance(requiredClearance)) {
            next();
        } else {
            next({ name: 'HomePage' });
        }
    } else {
        next();
    }
});


export default router;